'use client';
import { Box, Grid } from '@mui/material';
import { useTranslation } from '@/hook';
import { banners, bannersAR } from '../../../../public/Images';
import Carousel from '@/components/shared/carousel/carousel.component';
import { AVAILABLE_LANGUAGES } from '@/constants';

const PropositionBanners = ({ containerWidth }: { containerWidth?: string }) => {
  const imageContainer = {
    width: '100%',
    height: '100%',
  };
  const { i18n, IS_RTL } = useTranslation();
  const banner = IS_RTL ? bannersAR : banners;
  return (
    <Grid item key={Math.random()} xs={12} sm={12} md={4} lg={4} xl={4}>
      <Box sx={imageContainer}>
        <Carousel
          slideShow={false}
          dragable={false}
          showDots={false}
          containerWidth={containerWidth || '70%'}
          imageMargin="8px"
          imgs={banner}
          UseNextImage={false}
          lang={i18n.language as AVAILABLE_LANGUAGES}
        ></Carousel>
      </Box>
    </Grid>
  );
};

export default PropositionBanners;
